import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const postCommunityPost = ({
  content,
  picture,
  isFixed = false,
  isCommentEnabled = false,
}) =>
  API.post('/users/me/communities/', {
    content,
    picture,
    isFixed,
    isCommentEnabled,
  });

const patchCommunityPost = (
  id,
  { content, picture, isFixed, isCommentEnabled }
) =>
  API.patch(`/users/me/communities/${id}/`, {
    content,
    picture,
    isFixed,
    isCommentEnabled,
  });

const deleteCommunityPost = (id) => API.delete(`/users/me/communities/${id}/`);

const likeCommunityPost = (id) => API.post(`/communities/${id}/like/`);

const getCommunityPosts = (id, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${id}/communities/?${params}`);
};

const getCommunityPost = (id) => {
  return API.get(`/communities/${id}/`);
};

const getCommunityPostsByIds = (ids = []) =>
  API.get(`/communities/?community_ids=${ids.join(',')}`);

export default {
  postCommunityPost,
  patchCommunityPost,
  deleteCommunityPost,
  likeCommunityPost,
  getCommunityPosts,
  getCommunityPost,
  getCommunityPostsByIds,
};



// WEBPACK FOOTER //
// ./src/app/apis/community.js